module.exports = __webpack_public_path__ + "img/house_image.6c086b9f.png";